import { debounce } from "lodash";

export const callDebounced = (delay: number, callable: (...arguments__: any[]) => void, ...arguments_: any[]) =>
    debounce((...arguments__) => callable(...arguments__), delay)(...arguments_);
